import { Action } from './action';
import { Event } from './event';
import { Step } from './step';
import { Trigger } from './trigger';

/**
 * Represente un workflow.
 */
export class Workflow {
    /**
     * Liste des triggers du workflow.
     */
    public triggers: Trigger[] = [];

    /**
     * Liste des actions du workflow.
     */
    public actions: Action[] = [];

    /**
     * Liste des évènement du workflow.
     */
    public events: Event[] = [];

    /**
     * Liste des étape du workflow.
     */
    public steps: Step[] = [];

    /**
     * Durée maximale d'execution du workflow avant la levée d'une alerte.
     */
    public maxDuration: number;

    /**
     * Valeur indiquant si le workflow est actif.
     */
    public isActive: boolean;

    /**
     * Ajoute un trigger au workflow.
     * @param trigger : Instance du trigger à ajouter.
     * @returns : L'id du trigger ajouté.
     */
    public addTrigger(trigger: Trigger): number {
        this.triggers.push(trigger);
        return trigger.id;
    }

    /**
     * Ajoute une action au workflow.
     * @param trigger : Instance de l'action à ajouter.
     * @returns : L'id de l'action ajouté.
     */
    public addAction(action: Action): number {
        this.actions.push(action);
        return action.id;
    }

    /**
     * Ajoute une étape au workflow.
     * @param trigger : Instance de l'étape à ajouter.
     * @returns : L'id de l'étape ajouté.
     */
    public addStep(step: Step): number {
        this.steps.push(step);
        return step.id;
    }

    /**
     * Ajoute un évènement au workflow.
     * @param trigger : Instance de l'évènement à ajouter.
     * @returns : L'id de l'évènement ajouté.
     */
    public addEvent(event: Event) {
        this.events.push(event);
    }

    /**
     * Retourne une une instance de Workflow à partir de sa representation JSON.
     * @param jsonRepresentation : Representation JSON du workflow.
     * @returns : Une instance de Workflow.
     */
    public static fromJson(jsonRepresentation: string): Workflow {
        if (!!jsonRepresentation) {
            const notTypedInstance = JSON.parse(jsonRepresentation);
            const typedInstance = Workflow.clone(notTypedInstance);

            return typedInstance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'une instance de Workflow
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: Workflow) {
        if (!!other) {
            const instance = new Workflow();
            instance.maxDuration = other.maxDuration;
            instance.isActive = other.isActive;
            instance.triggers = Trigger.cloneArray(other.triggers);
            instance.actions = Action.cloneArray(other.actions);
            instance.steps = Step.cloneArray(other.steps);
            instance.events = Event.cloneArray(other.events);

            return instance;
        } else {
            return null;
        }
    }
}
